import { ImageQuery } from "types/imageQueries";

export const SET_CURRENT_INDEX = "setCurrentIndex";
export const SET_IMAGE_QUERY = "setImageQuery";
export const SET_LOADING = "setLoading";

interface QueryDetailsModalState {
  posicheck: ImageQuery | undefined;
  loadingLabels: boolean;
}

interface SetCurrentIndexAction {
  type: typeof SET_CURRENT_INDEX;
  payload: number;
}

interface SetImageQueryAction {
  type: typeof SET_IMAGE_QUERY;
  payload: ImageQuery;
}

interface SetLoadingAction {
  type: typeof SET_LOADING;
  payload: boolean;
}

export type QueryDetailsModalActions = SetCurrentIndexAction | SetImageQueryAction | SetLoadingAction;

// Reducer function that will handle state updates
export function queryDetailsModalReducer(state: QueryDetailsModalState, action: QueryDetailsModalActions) {
  switch (action.type) {
    case SET_CURRENT_INDEX:
      return { ...state, currentIndex: action.payload as number };
    case SET_IMAGE_QUERY:
      return {
        ...state,
        posicheck: action.payload as ImageQuery,
      };
    case SET_LOADING:
      return { ...state, loadingLabels: action.payload as boolean };

    default:
      throw new Error("Unsupported action type");
  }
}
